import React from 'react';
import InputField from '../components/InputField';
import styles from '../capitalExpenditure.module.scss';

const SecondQuarter = ({ 
  row, 
  viewMode, 
  handleInputChange, 
  handleOperationalRowChange, 
  isOperational = false 
}) => {
  const onChangeHandler = isOperational ? handleOperationalRowChange : handleInputChange;
  
  return (
    <>
      {/* Quarter 2 Columns */}
      <td className={styles.budgetCell}>
        <InputField
          value={row.q2BudgetDemand}
          onChange={(e, englishValue) => onChangeHandler(row.id, 'q2BudgetDemand', englishValue || e.target.value)}
          placeholder="0"
          readOnly={viewMode}
          viewMode={viewMode}
          isNumeric={true}
        />
      </td>
      <td className={styles.budgetCell}>
        <InputField
          value={row.q2BudgetExpenditure}
          onChange={(e, englishValue) => onChangeHandler(row.id, 'q2BudgetExpenditure', englishValue || e.target.value)}
          placeholder="0"
          readOnly={viewMode}
          viewMode={viewMode}
          isNumeric={true}
        />
      </td>
      <td className={styles.budgetCell}>
        <InputField
          value={row.q2AuthorityReceived}
          onChange={(e, englishValue) => onChangeHandler(row.id, 'q2AuthorityReceived', englishValue || e.target.value)}
          placeholder="0"
          readOnly={viewMode}
          viewMode={viewMode}
          isNumeric={true}
        />
      </td>
      <td className={styles.budgetCell}>
        <InputField
          value={row.q2Expense}
          onChange={(e, englishValue) => onChangeHandler(row.id, 'q2Expense', englishValue || e.target.value)}
          placeholder="0"
          readOnly={viewMode}
          viewMode={viewMode}
          isNumeric={true}
        />
      </td>
      <td className={styles.budgetCell}>
        <InputField
          value={row.q2RemainingBalance}
          placeholder="0"
          readOnly={true}
          viewMode={viewMode}
          isNumeric={true}
        />
      </td>
    </>
  );
};

export default SecondQuarter;
